import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { TextField, Container, Grid, Button, Card } from "@mui/material";
import HeaderSession from "../../../utils/headerSession";
import InputDocUpload from "../../../utils/inputFileUpload/inputDocUpload";
import ButtonLeft from "../../../utils/buttonLeft";
import MessageError from "../../../messages/messageError";
import MessageSuccess from "../../../messages/messageSuccess";
import { useSelector } from "react-redux";

interface NovoMedicamento {
  nome: string;
  dciDosagem: string;
  areaTerapeutica: string;
  apresentacao: string;
  fabricante: string;
  titularAIM: string;
  numeroRegisto: string;
  folhetoInformativo: string;
  rcm: string;
  dataRegisto: string;
}

const RegistrarMedicamento: React.FC = () => {
  const user = useSelector((state: any) => state?.account.user);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [novoMedicamento, setNovoMedicamento] = useState<NovoMedicamento>({
    nome: "",
    dciDosagem: "",
    areaTerapeutica: "",
    apresentacao: "",
    fabricante: "",
    titularAIM: "",
    numeroRegisto: "",
    folhetoInformativo: "",
    rcm: "",
    dataRegisto: "",
  });
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const navigate = useNavigate();

  const HandleChangeFile = (file: any, name: any) => {
    setNovoMedicamento((prevCadastro) => ({ ...prevCadastro, [name]: file }))
  }

  const handleSubmit = () => {
    setIsLoading(true)
    if (!novoMedicamento.nome || !novoMedicamento.dciDosagem) {
      setError("Preencha todos os campos obrigatórios.");
      return;
    }
    const formData = new FormData();
    formData.append("nome", novoMedicamento.nome);
    formData.append("dciDosagem", novoMedicamento.dciDosagem);
    formData.append("areaTerapeutica", novoMedicamento.areaTerapeutica);
    formData.append("apresentacao", novoMedicamento.apresentacao);
    formData.append("fabricante", novoMedicamento.fabricante);
    formData.append("titularAIM", novoMedicamento.titularAIM);
    formData.append("numeroRegisto", novoMedicamento.numeroRegisto);
    formData.append("folhetoInformativo", novoMedicamento.folhetoInformativo);
    formData.append("rcm", novoMedicamento.rcm);
    formData.append("dataRegisto", novoMedicamento.dataRegisto);
    formData.append("userId", user?._id);

    api.post("/medicamento-aim/register", formData)
      .then(() => {
        setSuccess("Medicamento adicionado com sucesso!");
        navigate("/admin/tabela-geral-medicamentos");
      })
      .catch((err) => {
        setError(err?.response?.data?.message);
      }).finally(() => setIsLoading(false));
  };


  return (
    <Container>
      <HeaderSession title="ADICIONAR NOVO MEDICAMENTO" />
      <Card sx={{ padding: 2 }}>
        {error && (<MessageError message={error} />)}
        {success && <MessageSuccess message={success} />}

        <div style={{ display: "flex", gap: "1rem" }}>
          <TextField
            label="Nome *"
            variant="outlined"
            fullWidth
            margin="normal"
            size="small"
            value={novoMedicamento.nome}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                nome: e.target.value,
              }))
            }
          />

          <TextField
            label="DCI Dosagem *"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.dciDosagem}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                dciDosagem: e.target.value,
              }))
            }
          />

        </div>

        <div style={{ display: "flex", gap: "1rem" }}>
          <TextField
            label="Apresentação *"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.apresentacao}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                apresentacao: e.target.value,
              }))
            }
          />

          <TextField
            label="Área Terapeutica"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.areaTerapeutica}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                areaTerapeutica: e.target.value,
              }))
            }
          />

        </div>

        <div style={{ display: "flex", gap: "1rem" }}>


          <TextField
            label="Fabricante"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.fabricante}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                fabricante: e.target.value,
              }))
            }
          />
          <TextField
            label="Titular AIM"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.titularAIM}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                titularAIM: e.target.value,
              }))
            }
          />
        </div>

        <div style={{ display: "flex", gap: "1rem" }}>
          <TextField
            label="Número de registo"
            variant="outlined"
            fullWidth
            size="small"
            margin="normal"
            value={novoMedicamento.numeroRegisto}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                numeroRegisto: e.target.value,
              }))
            }
          />

          <TextField
            fullWidth
            label="Data de Registo"
            type="date"
            size="small"
            variant="outlined"
            margin="normal"
            value={novoMedicamento.dataRegisto}
            onChange={(e) =>
              setNovoMedicamento((prev) => ({
                ...prev,
                dataRegisto: e.target.value,
              }))
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </div>

        {/* <FileUpload fullWidth={true} onFileSelect={(file) => HandleChangeFile(file, 'file')} /> */}

        <Grid container style={{ marginTop: 12 }}>
          <Grid m={1} xs={12} md item>
            <InputDocUpload
              onFileSelect={HandleChangeFile}
              inputName={'folhetoInformativo'}
              inputDescription={'Folheto Informátivo, na língua portuguesa (alternativamente na língua inglesa/francesa ou espanhola)'}
              inputTitle={'Folheto Informátivo'}
            />
          </Grid>

          <Grid m={1} xs={12} md item>
            <InputDocUpload
              onFileSelect={HandleChangeFile}
              inputName={'rcm'}
              inputDescription={'RCM'}
              inputTitle={'RCM'}
            />
          </Grid>
        </Grid>

        <br />
        <ButtonLeft
          title="Salvar"
          funcao={handleSubmit}
          load={isLoading}
          disabled={''}
        >
          <Button
            color="warning"
            // variant="outlined"
            onClick={() => navigate("/admin/tabela-geral-medicamentos")}
          >
            Cancelar
          </Button>
        </ButtonLeft>
      </Card>
    </Container >
  );
};

export default RegistrarMedicamento;
